import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { NumberOfCollectionEventsModel, HeaderModel } from "./";
import { CollectionIssueEventModel } from "@/api/CollectionIssueHistory/models";

export type PostReportSearchRequest = {
  reportType: string;
  startAt: Date;
  endAt: Date;
  wasteStreamIds: number[];
  suburbs: string[];
  streets: string[];
  collectionIssueTypeCategories: number[];
  letterTemplateNames: string[];
};

export type PostReportSearchResponse = {
  headers: HeaderModel[];
  results: CollectionIssueEventModel[] | NumberOfCollectionEventsModel[];
};

export const postReportSearch = async (request: PostReportSearchRequest) => {
  const response = await executeApiRequest(
    () => axios.post<PostReportSearchResponse>("/reports/search", request, { withCredentials: true }),
    false
  );
  return response.data;
};
